var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSystemDesignIcon = function SvgSystemDesignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 326"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 308,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 163,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 163,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 265,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 265,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 60,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157 270.332 5.5 2.072 4.5-1.695V308h-10zm89.742-29.662 21.324 21.325-7.071 7.071-24.527-24.526zm-169.211-.274 10.274 3.87-24.8 24.8-7.071-7.071zM261.752 158H307v10h-45.248zM63.247 168H17v-10h46.247zm-.242-111.066 28.592 28.591-9.64 4.504-26.023-26.024zm197.99 0 7.071 7.071-25.705 25.705-9.641-4.503zM167 18v36.506l-4.5-2.102-5.5 2.569V18z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 22,
    d: "m163.5 79.045 75.17 35.115v103.673L163.5 246.15l-75.17-28.317V114.16z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.728 129.144-53.275 19.243v75.688l53.275-19.675M106.453 129.144l53.275 19.243v75.688L106.453 204.4M163.5 99.891l-51.007 22.662L163.5 142.21l51.402-19.657z"
  })))));
};
export default SvgSystemDesignIcon;